<template>
  <div class="config-setting-dialog">
    <el-dialog
      :width="isMaximized ? '100%' : '70%'"
      :visible.sync="dialogVisible"
      :title="title"
      :close-on-click-modal="false"
      :fullscreen="isMaximized"
      @close="handleClose"
      append-to-body
      :show-close="false"
    >
      <template slot="title">
        <div class="dialog-title-wrapper">
          <span>{{ title }}</span>
          <div class="dialog-controls">
            <el-button
              type="text"
              size="mini"
              :icon="
                isMaximized ? 'el-icon-copy-document' : 'el-icon-full-screen'
              "
              @click="toggleMaximize"
              :title="isMaximized ? '还原' : '最大化'"
              class="control-btn"
            ></el-button>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-close"
              @click="handleClose"
              title="关闭"
              class="control-btn"
            ></el-button>
          </div>
        </div>
      </template>
      <el-tabs v-model="activeTab">
        <el-tab-pane
          v-for="item in tabOptions"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        >
          <component
            :is="item.component"
            :isMaximized="isMaximized"
            @cancel="handleClose"
            @save="handleSave"
          ></component>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import personalSetting from "@/components/developerInfo/components/personalSetting.vue";
import functionSetting from "@/components/developerInfo/components/functionSetting.vue";

export default {
  name: "ConfigSettingDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "设置",
    },
    // 用户权限列表
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    personalSetting,
    functionSetting,
  },
  data() {
    return {
      activeTab: "", // 当前激活的 tab
      isMaximized: false, // 是否最大化
      allTabOptions: [
        {
          name: "personalSetting",
          label: "个人设置",
          component: "personalSetting",
          permission: "CustomerPersonalSettingBtn",
        },
        {
          name: "functionSetting",
          label: "组织配置",
          component: "functionSetting",
          permission: "CustomerFunctionSettingBtn",
        },
      ],
    };
  },
  watch: {
    tabOptions: {
      handler(value) {
        // 设置默认值
        if (!value || value.length === 0) {
          this.activeTab = "";
        } else {
          this.activeTab = value[0].name;
        }
      },
      immediate: true,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    tabOptions() {
      return this.allTabOptions.filter(
        (item) =>
          !item.permission || this.permissions.includes(item.permission),
      );
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    handleSave() {
      this.dialogVisible = false;
      this.$emit("save");
    },
    toggleMaximize() {
      this.isMaximized = !this.isMaximized;
    },
  },
};
</script>

<style scoped>
.config-setting-dialog {
  .el-dialog__body {
    padding: 0 12px 16px;
  }
}

.dialog-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .dialog-controls {
    display: flex;
    align-items: center;
    gap: 8px;

    .control-btn {
      padding: 0;
      margin: 0;
      font-size: 16px;
      height: 32px;
      line-height: 32px;
    }

    .control-btn:hover {
      color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// configSettingDialog.vue?09b9f80d